import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const NewsBarContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-newsbarcontainer" */ "./NewsBarContainer")).then((page)=>{
        return {
            default: page.NewsBarContainer
        };
    });
export const LazyNewsBarContainer = /*#__PURE__*/ lazy(NewsBarContainerLazyLoader);
